var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHappyC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 85.04C66.0031 85.04 85.04 66.0031 85.04 42.52C85.04 19.0369 66.0031 0 42.52 0C19.0368 0 0 19.0369 0 42.52C0 66.0031 19.0368 85.04 42.52 85.04Z",
    fill: "#FCC332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2899 53.4801C66.0399 53.4801 65.7899 53.4301 65.5499 53.3401L56.7399 49.8201C55.9699 49.5101 55.4699 48.77 55.4799 47.94C55.4799 47.11 55.9999 46.3801 56.7799 46.0901L65.5899 42.7901C66.6299 42.4101 67.7799 42.9301 68.1699 43.9601C68.5599 44.9901 68.0299 46.1501 66.9999 46.5401L63.0299 48.03L67.0399 49.6401C68.0699 50.0501 68.5599 51.2101 68.1499 52.2401C67.8399 53.0201 67.0899 53.5001 66.2899 53.5001V53.4801Z",
    fill: "#331100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7399 53.48C17.9499 53.48 17.1999 53 16.8799 52.22C16.4699 51.19 16.9699 50.03 17.9899 49.62L22.0099 48.01L18.0399 46.52C17.0099 46.13 16.48 44.98 16.87 43.94C17.26 42.91 18.4099 42.39 19.4499 42.77L28.2599 46.07C29.0299 46.36 29.55 47.1 29.56 47.92C29.56 48.75 29.0699 49.49 28.2999 49.8L19.4899 53.32C19.2499 53.42 18.99 53.46 18.75 53.46L18.7399 53.48Z",
    fill: "#331100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.21 58.17C30.56 64.28 35.9999 68.85 42.5099 68.85C49.0199 68.85 54.46 64.28 55.81 58.17H29.2H29.21Z",
    fill: "#331100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5499 66.27C36.7899 67.89 39.5399 68.86 42.5199 68.86C45.4999 68.86 48.2499 67.9 50.4899 66.27C48.8299 64.01 45.8799 62.51 42.5199 62.51C39.1599 62.51 36.2199 64.01 34.5499 66.27Z",
    fill: "#FF301A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHappyC);
export default __webpack_public_path__ + "static/media/ic_happy_c.cbf5124358dc9c9390496f579e1b1ade.svg";
export { ForwardRef as ReactComponent };